import { h, Component } from 'preact'
import { Text } from 'preact-i18n'
import Button from '../Button'

export default ({reset}) => 
    <div>
        <h3><strong><Text id="success.headline" /></strong></h3><br/>
        <p><Text id="success.text" /></p>
        <p><Text id="success.team" /></p>
        <Button class="button-grey" onClick={reset}><Text id="success.button" /></Button>
    </div>



// WEBPACK FOOTER //
// ./js/components/Form/Success.js